export const getJustDate = (date) => {
  const [justDate] = date.split('T')

  const brDate = justDate.split('-').reverse().join('/')

  return brDate
}
